/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 28.04.2016.
 */

import React, {Component, PropTypes} from 'react';
import ReactDOM from 'react-dom';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import moment from 'moment';

import ClassNames from 'classnames';
import ScrollArea from '../../../../ScrollArea';

import {
  StubFunc,
  getScroll,
  RDVR_STATES
} from '../../../../../utils';

import {FetchAssetById} from '../../../../../actions/asset/action-asset';

import {
  AddEventToSchedule,
  CancelRecoding
} from '../../../../../actions/npvr/action-npvr';

import {
  AddNotification,
  RemoveNotification
} from '../../../../../actions/notifications/actions-notifications';

import {
  SetPlayer,
  SetSettingsState,
  OpenMessage
} from '../../../../../actions/common/actions-common';

import {ACTIONS} from '../../../../../containers/Player';

import DivLoader from '../../../../DivLoader';
import Translate from '../../../../Translate';

import _get from 'lodash/get';
import _find from 'lodash/find';
import _merge from 'lodash/merge';

class EpgEventProfile extends Component {
  constructor(props) {
    super(props);

    let now = moment().unix();

    this.state = {
      channelLogo: `/images/${Config.white_skin ? 'white' : 'black'}/no-channel-logo.png`,
      picture: `/images/${Config.white_skin ? 'white' : 'black'}/event-no-image.png`,
      streamUrl: '',
      isPlayerShowed: false,
      streamCategory: null,
      momentStart: moment.unix(_get(this.props, 'event.start')),
      momentEnd: moment.unix(_get(this.props, 'event.start') + _get(this.props, 'event.duration')),
      isNow: (_get(this.props, 'event.start') <= now) && (_get(this.props, 'event.start') + _get(this.props, 'event.duration') > now),
      isPast: now > _get(this.props, 'event.start') + _get(this.props, 'event.duration'),
      isFuture: now < _get(this.props, 'event.start')
    };
  }

  componentDidMount() {

    if (this.props.event.id) this._fetchEpgEventData(this.props.event);

    let rdvrDevice = _find(this.props.rdvr_devices, {extid: 'x:npvr'});
    if (rdvrDevice) {
      this.setState({rdvrDevice: rdvrDevice});
    }

    (this.state.isNow || this.props.forceLive) && !this._isNeedToPurchase() && !this.props.playerIsDetached && setTimeout(() => {
      this._startPlayback('live_hls');
    }, 350);

    if (this.props.channel.id) {

      lh.models.asset.methods
        .getPosterUrl(this.props.channel, {
          crop: {x: 100, y: 100},
          cache: false
        })
        .then((url) => {
          this.setState({channelLogo: url});
        }, () => {
          this.setState({channelLogo: `/images/${Config.white_skin ? 'white' : 'black'}/no-channel-logo.png`});
        });
    }
  }

  componentWillReceiveProps(newProps) {

    let now = moment().unix();

    let newState = {
      isNow: (_get(newProps, 'event.start') <= now) && (_get(newProps, 'event.start') + _get(newProps, 'event.duration') > now),
      isPast: now > _get(newProps, 'event.start') + _get(newProps, 'event.duration'),
      isFuture: now < _get(newProps, 'event.start')
    };

    if (this.props.event.id !== newProps.event.id) {
      this._stopPlayback();

      newState = _merge(newState, {
        picture: `/images/${Config.white_skin ? 'white' : 'black'}/event-no-image.png`,
        streamCategory: null,
        momentStart: moment.unix(newProps.event.start),
        momentEnd: moment.unix(newProps.event.start + newProps.event.duration)
      });

      this._fetchEpgEventData(newProps.event);

      (newState.isNow || newProps.forceLive) && !this._isNeedToPurchase() && !newProps.playerIsDetached && setTimeout(() => {
        this._startPlayback('live_hls');
      }, 350);
    }

    let rdvrDevice = _find(newProps.rdvr_devices, {extid: 'x:npvr'});
    if (rdvrDevice) {
      newState.rdvrDevice = rdvrDevice;
    }

    if (newProps.playerIsDetached) {

      newState.isPlayerShowed = false;
    }

    if (newProps.channel.id && newProps.channel.id !== this.props.channel.id) {
      lh.models.asset.methods
        .getPosterUrl(newProps.channel, {
          crop: {x: 100, y: 100},
          cache: false
        })
        .then((url) => {
          this.setState({channelLogo: url});
        }, () => {
          this.setState({channelLogo: `/images/${Config.white_skin ? 'white' : 'black'}/no-channel-logo.png`});
        });
    }

    this.setState(newState);
  }

  componentWillUnmount() {

    this._stopPlayback();
  }

  _fetchEpgEventData(event) {

    lh.common.resources
      .getPictureByCategory(event.program.resources, 'poster_blueprint', {
        crop: {x: 460, y: 270},
        cache: false
      })
      .then((url) => {
        this.setState({picture: url});
      }, () => {
        this.setState({picture: `/images/${Config.white_skin ? 'white' : 'black'}/event-no-image.png`});
      });
  };

  _startPlayback(type) {
    if (this.props.user.user === 'guest') {

      this.props.SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      });

      return;
    }

    if (!this.props.channel.is_purchased && !this.props.channel.is_available && !this.props.channel.is_free) {

      this._showOffers();
      return;
    }

    if (_get(this.props.user, 'data.is_blocked')) {
      this.setState({isPlayerShowed: !this.props.playerIsDetached && true});

      this.props.SetPlayer({
        stream_url: null,
        action: ACTIONS.BLOCK,
        container: ReactDOM.findDOMNode(this),
        type: 'blocker',
      });

      return;
    }

    if (type === 'live_hls') {
      lh.models.channelAsset.methods.getStreamUrl(_get(this.props, 'channel', {}))
        .then((stream) => {

          this.setState({streamUrl: stream, isPlayerShowed: !this.props.playerIsDetached && true, streamCategory: 'live_hls'});
          this.props.SetPlayer({
            stream_url: stream,
            container: ReactDOM.findDOMNode(this),
            action: ACTIONS.OPEN,
            //type: 'clpp',
            type: 'rmp',
            stream_type: type,
            monitoring: {
              assetTitle: _get(this.props, 'channel.title'),
              assetID: _get(this.props, 'channel.id'),
              lcn: _get(this.props, 'channel.er_lcn') || _get(this.props, 'channel.lcn'),
              programID: _get(this.props, 'event.id'),
              duration: _get(this.props, 'event.duration'),
              type: 'channel'
            },
            get_url_again_fn: lh.models.channelAsset.methods.getStreamUrl.bind(this, _get(this.props, 'channel', {})),
            vlive: _get(this.props, 'channel.channel_type', null) === 'playlist' ? _get(this.props, 'channel.id', null) : null,
            vlive_icon: this.state.channelLogo,
          });
        }, this._processStreamError);

    } else if (type === 'catchup_hls') {

      lh.catchup.getStream(this.props.event.id)
        .then((stream) => {

          this.setState({streamUrl: stream, isPlayerShowed: true, streamCategory: 'catchup_hls'});

          this.props.SetPlayer({
            stream_url: stream,
            container: ReactDOM.findDOMNode(this),
            action: ACTIONS.OPEN,
            //type: 'clpp',
            type: 'rmp',
            stream_type: type,
            monitoring: {
              assetTitle: _get(this.props, 'channel.title'),
              assetID: _get(this.props, 'channel.id'),
              programID: _get(this.props, 'event.id'),
              duration: _get(this.props, 'event.duration'),
              type: 'catchup'
            },
            get_url_again_fn: lh.catchup.getStream.bind(this, this.props.event.id)
          });
        }, this._processStreamError);
    } else if (type === 'rdvr_hls') {

      lh.models.asset.methods.getStreamUrl(this.props.event)
        .then((stream) => {

          this.setState({streamUrl: stream, isPlayerShowed: true, streamCategory: 'rdvr_hls'});

          this.props.SetPlayer({
            stream_url: stream,
            container: ReactDOM.findDOMNode(this),
            action: ACTIONS.OPEN,
            //type: 'clpp',
            type: 'rmp',
            stream_type: type,
            monitoring: {
              assetTitle: _get(this.props, 'channel.title'),
              assetID: _get(this.props, 'channel.id'),
              programID: _get(this.props, 'event.id'),
              duration: _get(this.props, 'event.duration'),
              type: 'catchup'
            },
            get_url_again_fn: lh.models.asset.methods.getStreamUrl.bind(this, this.props.event)
          });
        }, this._processStreamError);
    }
  }

  _stopPlayback() {

    this.setState({isPlayerShowed: false});

    this.props.SetPlayer({
      stream_url: '',
      container: null,
      action: ACTIONS.CLOSE,
      monitoring: null
    });
  }

  _showOffers() {
    if (this.props.user.user === 'guest') {

      this.props.SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      });

      return;
    }

    this.props.OpenMessage({
      type: 'offers',
      asset_id: this.props.channel.id,
      actions: [
        {
          title: 'no_thanks',
          func: () => {
          }
        }
      ]
    });
  }

  _addRecord(event) {
    if (this._isNeedToPurchase()) {
      this._showOffers();

      return;
    }

    if (this._isRdvrAvailable()) this.props.AddEventToSchedule(event.id, this.state.rdvrDevice);
  }

  _removeRecord(event) {
    if (this._isNeedToPurchase()) {
      this._showOffers();

      return;
    }

    if (this._isRdvrAvailable() && event.record) this.props.CancelRecoding(event.record.id);
  }

  _addNotification(event) {

    this.props.AddNotification(event.id);
  }

  _removeNotification(event) {

    if (event.notification) this.props.RemoveNotification(event.notification.id);
  }

  _closeProfile() {

    this.props.onClose();
    this._stopPlayback();
  }

  _isNeedToPurchase(asset = this.props.channel) {

    return !asset.is_purchased && !asset.is_available && !asset.is_free;
  }

  _isRdvrAvailable() {

    return !!this.state.rdvrDevice && this._isFuture();
  }

  _isFuture() {
    let now = moment().unix();

    return _get(this.props, 'event.start') > now;
  }

  _hasSubTitle() {

    return _get(this.props, 'event.title') !== _get(this.props, 'event.program.title');
  }

  _showPlayButton() {

    //TODO: Playback npvr from EPG
    return !this.state.isPlayerShowed && this.state.isPast && _get(this.props, 'event.is_catchup_available') ||
      //this.state.isPast && _get(this.props, 'event.record') ||
      this.state.isNow;
  }

  _onPlayerClick() {
    if (this.state.isPlayerShowed) return;

    if (this.state.isNow) {
      this._startPlayback('live_hls');
    } else if (this.state.isPast && _get(this.props, 'event.is_catchup_available')) {
      this._startPlayback('catchup_hls');
    }
  }

  _processStreamError = (reason) => {
    if (_get(reason, 'message') === 'subscriber blocked') {
      this.setState({isPlayerShowed: !this.props.playerIsDetached && true});

      this.props.SetPlayer({
        stream_url: null,
        action: ACTIONS.BLOCK,
        container: ReactDOM.findDOMNode(this),
        type: 'blocker',
      });
    } else if (_get(reason, 'message') === 'the requested content is not available in your geographical location') {
      this.setState({isPlayerShowed: !this.props.playerIsDetached && true});

      this.props.SetPlayer({
        stream_url: null,
        action: ACTIONS.GEO_BLOCK,
        container: ReactDOM.findDOMNode(this),
        type: 'geo-blocker',
      });
    } else {
      //TODO: SHOW ERROR CODE
      console.log('Failed:', reason);
    }
  };

  _renderNotificationButton() {

    if (!_get(this.props.event, 'notification')) {

      return (
        <div className="mt-">
          <div className="color-grey pv-"><Translate content="profile.epg_event.remind_me" /></div>
          <div>
            <a href="javascript:void(0)" className="hover" onClick={this._addNotification.bind(this, this.props.event)}>
              <i className="ic ic-notification-add ic-24px"></i>
            </a>
          </div>
        </div>
      );
    } else {

      return (
        <div className="mt-">
          <div className="color-grey pv-"><Translate content="profile.epg_event.not_remind" /></div>
          <div>
            <a href="javascript:void(0)" className="hover" onClick={this._removeNotification.bind(this, this.props.event)}>
              <i className="ic ic-notification-remove ic-24px"></i>
            </a>
          </div>
        </div>
      );
    }
  }

  _renderRecordButton() {

    if (!_get(this.props, 'event.record')) {

      return (<div className="mt-">
        <div className="color-grey pv-"><Translate content="profile.npvr.record_add" /></div>
        <div>
          <a href="javascript:void(0)" className="hover" onClick={this._addRecord.bind(this, _get(this.props, 'event'))}>
            <i className="ic ic-record-add ic-24px"></i>
          </a>
        </div>
      </div>);
    } else {

      if ([RDVR_STATES.CANCELLED, RDVR_STATES.FAILED].indexOf(_get(this.props, 'event.record.state')) === -1) {
        if (RDVR_STATES.FINISHED !== _get(this.props, 'event.record.state')) {

          return (<div className="mt-">
            <div className="color-grey pv-"><Translate content="profile.npvr.schedule_remove" /></div>
            <div>
              <a href="javascript:void(0)" className="hover" onClick={this._removeRecord.bind(this, _get(this.props, 'event'))}>
                <i className="ic ic-record-remove ic-24px"></i>
              </a>
            </div>
          </div>);
        } else {
          return (<div className="mt-">
            <div className="color-grey pv-"><Translate content="profile.npvr.record_remove" /></div>
            <div>
              <a href="javascript:void(0)" className="hover" onClick={this._removeRecord.bind(this, _get(this.props, 'event'))}>
                <i className="ic ic-record-delete ic-24px"></i>
              </a>
            </div>
          </div>);
        }
      }
    }
  }

  render() {
    if (!this.props.event.id) return <div className="profile movie-inf-example movie-inf-profile bg-black radius"><DivLoader loading={true} /></div>;

    const playerDummyClasses = ClassNames({
      'hover pointer': this._showPlayButton(),
      'crow no-gutter player-dummy': true
    });

    return (
      <div className="profile event-inf-example bg-black radius">
        <DivLoader loading={this.props.inProgress} />
        <div className="profile-cols relative">
          <div className="channel-player-dummy relative">
            <div className={playerDummyClasses} onClick={this._onPlayerClick.bind(this)} style={{display: this.state.isPlayerShowed ? 'none' : 'block'}}>
              {!this.state.isPlayerShowed ? <img id="profile_poster" src={this.state.picture} alt="" /> : null}
              {!this._isNeedToPurchase() && this._showPlayButton() && <img src={`/images/${Config.white_skin ? 'white' : 'black'}/play.png`} style={{position: 'absolute', top: '50%', left: '50%', marginTop: '-30px', marginLeft: '-25px'}} />}
              { this._isNeedToPurchase() && this._showPlayButton() && <i className="ic ic-shopping-cart ic-32px" style={{position: 'absolute', top: '50%', left: '50%', marginTop: '-22px', marginLeft: '-18px'}}></i>}
            </div>
          </div>
          <div className="block-3 event-desc">
            <div>
              <div className="channel-title mt+">
                <b>{_get(this.props, 'channel.title', '')}</b>
              </div>
              <br />
              <div className="profile-bigtext">
                {this.state.momentStart.format(_get(Config, 'epg.epg_event_time_format', 'HH:mm'))} - {this.state.momentEnd.format(_get(Config, 'epg.epg_event_time_format', 'HH:mm'))}
              </div>
              <div className="program-title">
                {_get(this.props.event, 'program.title', '')}
              </div>
              <ScrollArea
                speed={0.8}
                className="color-grey profile-text"
                horizontal={false}
                smoothScrolling={true}>
                <div>
                  <div className="program-title mb-">
                    {this._hasSubTitle() && <span className="program-title color-white">{_get(this.props, 'event.title')}</span>}
                  </div>
                  {_get(this.props.event, 'description', '')}
                </div>
              </ScrollArea>
            </div>
          </div>
          <div className="block-1" />
          <div className="block-1 col-last">
            <div className="profile-r pr">
              <div className="profile-actions pr">
                {this._isFuture() && this._renderNotificationButton()}
                {this._isRdvrAvailable() && this._renderRecordButton()}
              </div>
            </div>
          </div>
        </div>
        <a href="javascript:void(0)" className="mw-close ico ico-close slider-resume pointer" onClick={this._closeProfile.bind(this)}></a>
      </div>
    );
  }
}

EpgEventProfile.propTypes = {
  eventId: PropTypes.number.isRequired,
  event: PropTypes.object.isRequired,
  forceLive: PropTypes.bool.isRequired,
  user: PropTypes.object,
  rdvr_devices: PropTypes.array,
  onClose: PropTypes.func.isRequired,
  FetchAssetById: PropTypes.func.isRequired,
  SetPlayer: PropTypes.func.isRequired,
  SetSettingsState: PropTypes.func.isRequired,
  OpenMessage: PropTypes.func.isRequired,
  AddEventToSchedule: PropTypes.func.isRequired,
  CancelRecoding: PropTypes.func.isRequired,
  AddNotification: PropTypes.func.isRequired,
  RemoveNotification: PropTypes.func.isRequired
};

EpgEventProfile.defaultProps = {
  onClose: StubFunc.bind(this, 'onClose from Event Profile')
};

const mapStateToProps = function ({auth: {user}, schedule: {event}, common: {devices: {rdvr_devices}, player}}, ownProps) {
  let eventForProfile = _get(event, ownProps.eventId);

  return {
    event: eventForProfile,
    user: user,
    rdvr_devices: rdvr_devices,
    playerIsDetached: !!player.isDetached
  };
};

const mapDispatchToProps = function (dispatch) {

  return bindActionCreators({FetchAssetById, SetPlayer, SetSettingsState, OpenMessage, AddEventToSchedule, CancelRecoding, AddNotification, RemoveNotification}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(EpgEventProfile);



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Profile/Types/EpgEvent/epg-event-profile.js